import * as React from 'react';
import styled from '@emotion/styled';
import {Trans} from 'react-i18next';
import {gray500} from 'wnd-themes/lib/colorPalette';

import {textSmRegular} from '>shared/components/typography/designSystemTypography';

import {WEBUI_TERMS_URL} from '>root/env';

const RECORDED_TOU_LOCALE = 'en';

export const CandidateDetailAccessTouDisclaimer: React.FC = () => {
  return (
    <DisclaimerText data-qa="integration-tou-disclaimer">
      <Trans ns="candidateDetail" i18nKey="touDisclaimer">
        {"By clicking Log in, you agree to Wonderlic's "}
        <a
          data-qa="integration-tou-disclaimer-terms-link"
          href={`${WEBUI_TERMS_URL}/terms-of-use/${RECORDED_TOU_LOCALE}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Use
        </a>
        {' and acknowledge our '}
        <a
          data-qa="integration-tou-disclaimer-privacy-link"
          href={`${WEBUI_TERMS_URL}/privacy/${RECORDED_TOU_LOCALE}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        .
      </Trans>
    </DisclaimerText>
  );
};

const DisclaimerText = styled.p`
  ${textSmRegular};
  color: ${gray500};
  margin-top: 0.8rem;
  text-align: left;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;
